import { Rectangle } from './Rectangle.js';
import { Circle } from './Circle.js';
import { FreeHand } from './FreeHand.js';
import { TextBox } from './TextBox.js';
import { Arrow } from './Arrow.js';
import { CommentStamp } from './CommentStamp.js';
import { drawingConstants } from '../drawing.constants.js';
import { PinPointer } from './PinPointer.js';
import { Highlight } from './Highlight.js';
import { StrikeOut } from './StrikeOut.js';
import { TextHighlight } from './TextHighlight.js';
const ShapeAction = {
    START: 'start',
    ADD: 'add',
    UPDATE: 'update'
};
class ShapeFactory {
    static createShape(shapeProps) {
        const { ANNOTATION_TYPE } = drawingConstants;
        switch (shapeProps.type) {
            case ANNOTATION_TYPE.rect.typeName:
                return new Rectangle({ ...shapeProps, type: ANNOTATION_TYPE.rect.shape });
            case ANNOTATION_TYPE.circle.typeName:
                return new Circle({ ...shapeProps, type: ANNOTATION_TYPE.circle.shape });
            case ANNOTATION_TYPE.textbox.typeName:
                return new TextBox({ ...shapeProps, type: ANNOTATION_TYPE.textbox.shape });
            case ANNOTATION_TYPE.path.typeName:
                return new FreeHand({ ...shapeProps, type: ANNOTATION_TYPE.path.shape });
            case ANNOTATION_TYPE.arrow.typeName:
                return new Arrow({ ...shapeProps, type: ANNOTATION_TYPE.arrow.shape });
            case ANNOTATION_TYPE.commentStamp.typeName:
                return new CommentStamp({
                    ...shapeProps,
                    type: ANNOTATION_TYPE.commentStamp.shape
                });
            case ANNOTATION_TYPE.pinPointer.typeName:
                return new PinPointer({
                    ...shapeProps,
                    type: ANNOTATION_TYPE.commentStamp.shape
                });
            case ANNOTATION_TYPE.highlight.typeName:
                return new Highlight({ ...shapeProps, type: ANNOTATION_TYPE.highlight.shape });
            
            case ANNOTATION_TYPE.strikeOut.typeName:
                return new StrikeOut({ ...shapeProps, type: ANNOTATION_TYPE.strikeOut.shape });
            case ANNOTATION_TYPE.textHighlight.typeName:
                return new TextHighlight({ ...shapeProps, type: ANNOTATION_TYPE.textHighlight.shape });                
            default:
                return;
        }
    }
    toString() {
        return Object.getPrototypeOf(this).constructor.name;
    }
}

export default ShapeFactory;

export { ShapeAction };
